'use strict';

export default {
  apiKey: "AIzaSyCeEB1_vxM1sexr2Ffxvzr2YzG_xgBOsD4",
  authDomain: "digital-you-website.firebaseapp.com",
  databaseURL: "https://digital-you-website.firebaseio.com",
  storageBucket: "digital-you-website.appspot.com",
};
